export default __webpack_public_path__ + "static/media/swedgo-screenshot-05.9d617788.png";